'use strict';

var GridToolbarSystemConfigurationController = function GridToolbarSystemConfigurationController($scope) {
  $scope.saveChanges = function () {
    var valuesColumn = $scope.jqxGridSettings.jqxGrid('getcolumn', 'propertyValue');
    if (valuesColumn.columnFieldsValidationErrors) {
      $scope.$emit('configuration-parameters-simple:validationErrorOnSave');
    } else {
      var rows = $scope.jqxGridSettings.jqxGrid('getrows');
      var data = rows.map(function (row) {
        return $scope.jqxGridSettings.jqxGrid('getrowdata', row.uid);
      });
      $scope.$emit('configuration-parameters-simple:saveChanges', data);
    }
  };
  $scope.$on('configuration-parameters-simple:saveSuccess', function () {
    $scope.clearModifiedCells();
  });
};
GridToolbarSystemConfigurationController.$inject = ['$scope'];
module.exports = GridToolbarSystemConfigurationController;